import apiRequest, { tokenStorage } from "./apiClient";

export async function login(email, password) {
  const body = await apiRequest("/api/v1/admin/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });

  const { accessToken, refreshToken, user } = body.data;
  tokenStorage.setTokens(accessToken, refreshToken);
  localStorage.setItem("spotdeal_admin_user", JSON.stringify(user));
  return user;
}

export async function logout() {
  try {
    await apiRequest("/api/v1/admin/auth/logout", { method: "POST" });
  } finally {
    tokenStorage.clear();
  }
}

export async function fetchCurrentAdmin() {
  const body = await apiRequest("/api/v1/admin/auth/me");
  return body.data;
}
